export const LOGIN_REQUEST = 'USERS_LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'USERS_LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'USERS_LOGIN_FAILURE';
export const LOGOUT = 'USERS_LOGOUT';

export const GET_DEFAULT_STEP = 'GET_DEFAULT_STEP';
export const ADD_BOOK_STEP = 'ADD_BOOK_STEP';
export const ADD_CAR_STEP = 'ADD_CAR_STEP';

export const MOVE_STEP_1_TO_FINISH = 'MOVE_STEP_1_TO_FINISH';
export const MOVE_STEP_2_TO_FINISH = 'MOVE_STEP_2_TO_FINISH';
export const MOVE_STEP_3_TO_FINISH = 'MOVE_STEP_3_TO_FINISH';
export const MOVE_STEP_4_TO_FINISH = 'MOVE_STEP_4_TO_FINISH';
export const MOVE_STEP_5_TO_FINISH = 'MOVE_STEP_5_TO_FINISH';
export const MOVE_STEP_CAR_TO_FINISH = 'MOVE_STEP_CAR_TO_FINISH';
export const MOVE_STEP_BOOK_TO_FINISH = 'MOVE_STEP_BOOK_TO_FINISH';

export const MOVE_STEP_1_TO_PROCESS = 'MOVE_STEP_1_TO_PROCESS';
export const MOVE_STEP_2_TO_PROCESS = 'MOVE_STEP_2_TO_PROCESS';
export const MOVE_STEP_3_TO_PROCESS = 'MOVE_STEP_3_TO_PROCESS';
export const MOVE_STEP_4_TO_PROCESS = 'MOVE_STEP_4_TO_PROCESS';
export const MOVE_STEP_5_TO_PROCESS = 'MOVE_STEP_5_TO_PROCESS';
export const MOVE_STEP_CAR_TO_PROCESS = 'MOVE_STEP_CAR_TO_PROCESS';
export const MOVE_STEP_BOOK_TO_PROCESS = 'MOVE_STEP_BOOK_TO_PROCESS';

export const FETCH_SPECS_TREE_REQUEST = 'FETCH_SPECS_TREE_REQUEST';
export const FETCH_SPECS_TREE_SUCCESS = 'FETCH_SPECS_TREE_SUCCESS';
export const FETCH_SPECS_TREE_FAILURE = 'FETCH_SPECS_TREE_FAILURE';

export const SAVE_ITEM_REQUEST = 'SAVE_ITEM_REQUEST';
export const SAVE_ITEM_SUCCESS = 'SAVE_ITEM_SUCCESS';
export const SAVE_ITEM_FAILURE = 'SAVE_ITEM_FAILURE';

export const FETCH_ITEMS_REQUEST = 'FETCH_ITEMS_REQUEST';
export const FETCH_ITEMS_SUCCESS = 'FETCH_ITEMS_SUCCESS';
export const FETCH_ITEMS_FAILURE = 'FETCH_ITEMS_FAILURE';

export const FETCH_ITEM_REQUEST = 'FETCH_ITEM_REQUEST';
export const FETCH_ITEM_SUCCESS = 'FETCH_ITEM_SUCCESS';
export const FETCH_ITEM_FAILURE = 'FETCH_ITEM_FAILURE';

export const DELETE_ITEM_REQUEST = 'DELETE_ITEM_REQUEST';
export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';
export const DELETE_ITEM_FAILURE = 'DELETE_ITEM_FAILURE';

export const FETCH_ITEM_IMAGE_REQUEST = 'FETCH_ITEM_IMAGE_REQUEST';
export const FETCH_ITEM_IMAGE_SUCCESS = 'FETCH_ITEM_IMAGE_SUCCESS';
export const FETCH_ITEM_IMAGE_FAILURE = 'FETCH_ITEM_IMAGE_FAILURE';

export const FETCH_ITEM_COMPLETE_REQUEST = 'FETCH_ITEM_COMPLETE_REQUEST';
export const FETCH_ITEM_COMPLETE_SUCCESS = 'FETCH_ITEM_COMPLETE_SUCCESS';
export const FETCH_ITEM_COMPLETE_FAILURE = 'FETCH_ITEM_COMPLETE_FAILURE';

export const FETCH_SIMPLE_ITEM_LIST_PDF_REQUEST =
  'FETCH_SIMPLE_ITEM_LIST_PDF_REQUEST';
export const FETCH_SIMPLE_ITEM_LIST_PDF_SUCCESS =
  'FETCH_SIMPLE_ITEM_LIST_PDF_SUCCESS';
export const FETCH_SIMPLE_ITEM_LIST_PDF_FAILURE =
  'FETCH_SIMPLE_ITEM_LIST_PDF_FAILURE';

export const FETCH_CUSTOM_ITEM_LIST_PDF_REQUEST =
  'FETCH_CUSTOM_ITEM_LIST_PDF_REQUEST';
export const FETCH_CUSTOM_ITEM_LIST_PDF_SUCCESS =
  'FETCH_CUSTOM_ITEM_LIST_PDF_SUCCESS';
export const FETCH_CUSTOM_ITEM_LIST_PDF_FAILURE =
  'FETCH_CUSTOM_ITEM_LIST_PDF_FAILURE';

export const SET_POI_AS_FILTERED = 'SET_POI_AS_FILTERED';
export const SET_POI_SEARCH_AS_ADVANCED = 'SET_POI_SEARCH_AS_ADVANCED';
export const UPDATE_POI_FILTER = 'UPDATE_POI_FILTER';
export const RESET_POI_FILTER = 'RESET_POI_FILTER';

export const SAVE_POI_REQUEST = 'SAVE_POI_REQUEST';
export const SAVE_POI_SUCCESS = 'SAVE_POI_SUCCESS';
export const SAVE_POI_FAILURE = 'SAVE_POI_FAILURE';

export const FETCH_POIS_REQUEST = 'FETCH_POIS_REQUEST';
export const FETCH_POIS_SUCCESS = 'FETCH_POIS_SUCCESS';
export const FETCH_POIS_FAILURE = 'FETCH_POIS_FAILURE';

export const FETCH_POIS_DROPDOWN_REQUEST = 'FETCH_POIS_DROPDOWN_REQUEST';
export const FETCH_POIS_DROPDOWN_SUCCESS = 'FETCH_POIS_DROPDOWN_SUCCESS';
export const FETCH_POIS_DROPDOWN_FAILURE = 'FETCH_POIS_DROPDOWN_FAILURE';

export const FETCH_POI_REQUEST = 'FETCH_POI_REQUEST';
export const FETCH_POI_SUCCESS = 'FETCH_POI_SUCCESS';
export const FETCH_POI_FAILURE = 'FETCH_POI_FAILURE';

export const DELETE_POI_REQUEST = 'DELETE_POI_REQUEST';
export const DELETE_POI_SUCCESS = 'DELETE_POI_SUCCESS';
export const DELETE_POI_FAILURE = 'DELETE_POI_FAILURE';

export const FETCH_POI_IMAGE_REQUEST = 'FETCH_POI_IMAGE_REQUEST';
export const FETCH_POI_IMAGE_SUCCESS = 'FETCH_POI_IMAGE_SUCCESS';
export const FETCH_POI_IMAGE_FAILURE = 'FETCH_POI_IMAGE_FAILURE';

export const FETCH_POI_COMPLETE_REQUEST = 'FETCH_POI_COMPLETE_REQUEST';
export const FETCH_POI_COMPLETE_SUCCESS = 'FETCH_POI_COMPLETE_SUCCESS';
export const FETCH_POI_COMPLETE_FAILURE = 'FETCH_POI_COMPLETE_FAILURE';

export const FETCH_SIMPLE_POI_LIST_PDF_REQUEST =
  'FETCH_SIMPLE_POI_LIST_PDF_REQUEST';
export const FETCH_SIMPLE_POI_LIST_PDF_SUCCESS =
  'FETCH_SIMPLE_POI_LIST_PDF_SUCCESS';
export const FETCH_SIMPLE_POI_LIST_PDF_FAILURE =
  'FETCH_SIMPLE_POI_LIST_PDF_FAILURE';

export const FETCH_CUSTOM_POI_LIST_PDF_REQUEST =
  'FETCH_CUSTOM_POI_LIST_PDF_REQUEST';
export const FETCH_CUSTOM_POI_LIST_PDF_SUCCESS =
  'FETCH_CUSTOM_POI_LIST_PDF_SUCCESS';
export const FETCH_CUSTOM_POI_LIST_PDF_FAILURE =
  'FETCH_CUSTOM_POI_LIST_PDF_FAILURE';

export const SAVE_POI_GROUP_REQUEST = 'SAVE_POI_GROUP_REQUEST';
export const SAVE_POI_GROUP_SUCCESS = 'SAVE_POI_GROUP_SUCCESS';
export const SAVE_POI_GROUP_FAILURE = 'SAVE_POI_GROUP_FAILURE';

export const FETCH_POI_GROUPS_REQUEST = 'FETCH_POI_GROUPS_REQUEST';
export const FETCH_POI_GROUPS_SUCCESS = 'FETCH_POI_GROUPS_SUCCESS';
export const FETCH_POI_GROUPS_FAILURE = 'FETCH_POI_GROUPS_FAILURE';

export const FETCH_POI_GROUPS_DROPDOWN_REQUEST =
  'FETCH_POI_GROUPS_DROPDOWN_REQUEST';
export const FETCH_POI_GROUPS_DROPDOWN_SUCCESS =
  'FETCH_POI_GROUPS_DROPDOWN_SUCCESS';
export const FETCH_POI_GROUPS_DROPDOWN_FAILURE =
  'FETCH_POI_GROUPS_DROPDOWN_FAILURE';

export const FETCH_POI_GROUP_REQUEST = 'FETCH_POI_GROUP_REQUEST';
export const FETCH_POI_GROUP_SUCCESS = 'FETCH_POI_GROUP_SUCCESS';
export const FETCH_POI_GROUP_FAILURE = 'FETCH_POI_GROUP_FAILURE';

export const DELETE_POI_GROUP_REQUEST = 'DELETE_POI_GROUP_REQUEST';
export const DELETE_POI_GROUP_SUCCESS = 'DELETE_POI_GROUP_SUCCESS';
export const DELETE_POI_GROUP_FAILURE = 'DELETE_POI_GROUP_FAILURE';

export const FETCH_POI_GROUP_COMPLETE_REQUEST =
  'FETCH_POI_GROUP_COMPLETE_REQUEST';
export const FETCH_POI_GROUP_COMPLETE_SUCCESS =
  'FETCH_POI_GROUP_COMPLETE_SUCCESS';
export const FETCH_POI_GROUP_COMPLETE_FAILURE =
  'FETCH_POI_GROUP_COMPLETE_FAILURE';

export const SAVE_BEACON_REQUEST = 'SAVE_BEACON_REQUEST';
export const SAVE_BEACON_SUCCESS = 'SAVE_BEACON_SUCCESS';
export const SAVE_BEACON_FAILURE = 'SAVE_BEACON_FAILURE';

export const FETCH_BEACONS_REQUEST = 'FETCH_BEACONS_REQUEST';
export const FETCH_BEACONS_SUCCESS = 'FETCH_BEACONS_SUCCESS';
export const FETCH_BEACONS_FAILURE = 'FETCH_BEACONS_FAILURE';

export const FETCH_BEACON_REQUEST = 'FETCH_BEACON_REQUEST';
export const FETCH_BEACON_SUCCESS = 'FETCH_BEACON_SUCCESS';
export const FETCH_BEACON_FAILURE = 'FETCH_BEACON_FAILURE';

export const FETCH_BEACON_IMAGE_REQUEST = 'FETCH_BEACON_IMAGE_REQUEST';
export const FETCH_BEACON_IMAGE_SUCCESS = 'FETCH_BEACON_IMAGE_SUCCESS';
export const FETCH_BEACON_IMAGE_FAILURE = 'FETCH_BEACON_IMAGE_FAILURE';

export const FETCH_BEACON_COMPLETE_REQUEST = 'FETCH_BEACON_COMPLETE_REQUEST';
export const FETCH_BEACON_COMPLETE_SUCCESS = 'FETCH_BEACON_COMPLETE_SUCCESS';
export const FETCH_BEACON_COMPLETE_FAILURE = 'FETCH_BEACON_COMPLETE_FAILURE';

export const FETCH_SIMPLE_BEACON_LIST_PDF_REQUEST =
  'FETCH_SIMPLE_BEACON_LIST_PDF_REQUEST';
export const FETCH_SIMPLE_BEACON_LIST_PDF_SUCCESS =
  'FETCH_SIMPLE_BEACON_LIST_PDF_SUCCESS';
export const FETCH_SIMPLE_BEACON_LIST_PDF_FAILURE =
  'FETCH_SIMPLE_BEACON_LIST_PDF_FAILURE';

export const FETCH_CUSTOM_BEACON_LIST_PDF_REQUEST =
  'FETCH_CUSTOM_BEACON_LIST_PDF_REQUEST';
export const FETCH_CUSTOM_BEACON_LIST_PDF_SUCCESS =
  'FETCH_CUSTOM_BEACON_LIST_PDF_SUCCESS';
export const FETCH_CUSTOM_BEACON_LIST_PDF_FAILURE =
  'FETCH_CUSTOM_BEACON_LIST_PDF_FAILURE';

export const SAVE_NEWS_REQUEST = 'SAVE_NEWS_REQUEST';
export const SAVE_NEWS_SUCCESS = 'SAVE_NEWS_SUCCESS';
export const SAVE_NEWS_FAILURE = 'SAVE_NEWS_FAILURE';

export const FETCH_NEWSS_REQUEST = 'FETCH_NEWSS_REQUEST';
export const FETCH_NEWSS_SUCCESS = 'FETCH_NEWSS_SUCCESS';
export const FETCH_NEWSS_FAILURE = 'FETCH_NEWSS_FAILURE';

export const FETCH_NEWS_REQUEST = 'FETCH_NEWS_REQUEST';
export const FETCH_NEWS_SUCCESS = 'FETCH_NEWS_SUCCESS';
export const FETCH_NEWS_FAILURE = 'FETCH_NEWS_FAILURE';

export const DELETE_NEWS_REQUEST = 'DELETE_NEWS_REQUEST';
export const DELETE_NEWS_SUCCESS = 'DELETE_NEWS_SUCCESS';
export const DELETE_NEWS_FAILURE = 'DELETE_NEWS_FAILURE';

export const FETCH_NEWS_COMPLETE_REQUEST = 'FETCH_NEWS_COMPLETE_REQUEST';
export const FETCH_NEWS_COMPLETE_SUCCESS = 'FETCH_NEWS_COMPLETE_SUCCESS';
export const FETCH_NEWS_COMPLETE_FAILURE = 'FETCH_NEWS_COMPLETE_FAILURE';

export const SAVE_APP_SETTINGS_REQUEST = 'SAVE_APP_SETTINGS_REQUEST';
export const SAVE_APP_SETTINGS_SUCCESS = 'SAVE_APP_SETTINGS_SUCCESS';
export const SAVE_APP_SETTINGS_FAILURE = 'SAVE_APP_SETTINGS_FAILURE';

export const FETCH_APP_SETTINGS_REQUEST = 'FETCH_APP_SETTINGS_REQUEST';
export const FETCH_APP_SETTINGS_SUCCESS = 'FETCH_APP_SETTINGS_SUCCESS';
export const FETCH_APP_SETTINGS_FAILURE = 'FETCH_APP_SETTINGS_FAILURE';

export const FETCH_APP_SETTINGS_COMPLETE_REQUEST =
  'FETCH_APP_SETTINGS_COMPLETE_REQUEST';
export const FETCH_APP_SETTINGS_COMPLETE_SUCCESS =
  'FETCH_APP_SETTINGS_COMPLETE_SUCCESS';
export const FETCH_APP_SETTINGS_COMPLETE_FAILURE =
  'FETCH_APP_SETTINGS_COMPLETE_FAILURE';

export const FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_REQUEST =
  'FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_REQUEST';
export const FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_SUCCESS =
  'FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_SUCCESS';
export const FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_FAILURE =
  'FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_FAILURE';

export const SAVE_CMS_LANGUAGE_REQUEST = 'SAVE_CMS_LANGUAGE_REQUEST';
export const SAVE_CMS_LANGUAGE_SUCCESS = 'SAVE_CMS_LANGUAGE_SUCCESS';
export const SAVE_CMS_LANGUAGE_FAILURE = 'SAVE_CMS_LANGUAGE_FAILURE';

export const FETCH_CMS_LANGUAGES_REQUEST = 'FETCH_CMS_LANGUAGES_REQUEST';
export const FETCH_CMS_LANGUAGES_SUCCESS = 'FETCH_CMS_LANGUAGES_SUCCESS';
export const FETCH_CMS_LANGUAGES_FAILURE = 'FETCH_CMS_LANGUAGES_FAILURE';

export const FETCH_CMS_LANGUAGE_REQUEST = 'FETCH_CMS_LANGUAGE_REQUEST';
export const FETCH_CMS_LANGUAGE_SUCCESS = 'FETCH_CMS_LANGUAGE_SUCCESS';
export const FETCH_CMS_LANGUAGE_FAILURE = 'FETCH_CMS_LANGUAGE_FAILURE';

export const DELETE_CMS_LANGUAGE_REQUEST = 'DELETE_CMS_LANGUAGE_REQUEST';
export const DELETE_CMS_LANGUAGE_SUCCESS = 'DELETE_CMS_LANGUAGE_SUCCESS';
export const DELETE_CMS_LANGUAGE_FAILURE = 'DELETE_CMS_LANGUAGE_FAILURE';

export const FETCH_CMS_LANGUAGE_IMAGE_REQUEST =
  'FETCH_CMS_LANGUAGE_IMAGE_REQUEST';
export const FETCH_CMS_LANGUAGE_IMAGE_SUCCESS =
  'FETCH_CMS_LANGUAGE_IMAGE_SUCCESS';
export const FETCH_CMS_LANGUAGE_IMAGE_FAILURE =
  'FETCH_CMS_LANGUAGE_IMAGE_FAILURE';

export const FETCH_CMS_LANGUAGE_COMPLETE_REQUEST =
  'FETCH_CMS_LANGUAGE_COMPLETE_REQUEST';
export const FETCH_CMS_LANGUAGE_COMPLETE_SUCCESS =
  'FETCH_CMS_LANGUAGE_COMPLETE_SUCCESS';
export const FETCH_CMS_LANGUAGE_COMPLETE_FAILURE =
  'FETCH_CMS_LANGUAGE_COMPLETE_FAILURE';

export const FETCH_SIMPLE_CMS_LANGUAGE_LIST_PDF_REQUEST =
  'FETCH_SIMPLE_CMS_LANGUAGE_LIST_PDF_REQUEST';
export const FETCH_SIMPLE_CMS_LANGUAGE_LIST_PDF_SUCCESS =
  'FETCH_SIMPLE_CMS_LANGUAGE_LIST_PDF_SUCCESS';
export const FETCH_SIMPLE_CMS_LANGUAGE_LIST_PDF_FAILURE =
  'FETCH_SIMPLE_CMS_LANGUAGE_LIST_PDF_FAILURE';

export const FETCH_CUSTOM_CMS_LANGUAGE_LIST_PDF_REQUEST =
  'FETCH_CUSTOM_CMS_LANGUAGE_LIST_PDF_REQUEST';
export const FETCH_CUSTOM_CMS_LANGUAGE_LIST_PDF_SUCCESS =
  'FETCH_CUSTOM_CMS_LANGUAGE_LIST_PDF_SUCCESS';
export const FETCH_CUSTOM_CMS_LANGUAGE_LIST_PDF_FAILURE =
  'FETCH_CUSTOM_CMS_LANGUAGE_LIST_PDF_FAILURE';

export const FETCH_CONDITION_COMPLETE_REQUEST =
  'FETCH_CONDITION_COMPLETE_REQUEST';
export const FETCH_CONDITION_COMPLETE_SUCCESS =
  'FETCH_CONDITION_COMPLETE_SUCCESS';
export const FETCH_CONDITION_COMPLETE_FAILURE =
  'FETCH_CONDITION_COMPLETE_FAILURE';

export const FETCH_TREATMENT_COMPLETE_REQUEST =
  'FETCH_TREATMENT_COMPLETE_REQUEST';
export const FETCH_TREATMENT_COMPLETE_SUCCESS =
  'FETCH_TREATMENT_COMPLETE_SUCCESS';
export const FETCH_TREATMENT_COMPLETE_FAILURE =
  'FETCH_TREATMENT_COMPLETE_FAILURE';

export const FETCH_MOVEMENT_COMPLETE_REQUEST =
  'FETCH_MOVEMENT_COMPLETE_REQUEST';
export const FETCH_MOVEMENT_COMPLETE_SUCCESS =
  'FETCH_MOVEMENT_COMPLETE_SUCCESS';
export const FETCH_MOVEMENT_COMPLETE_FAILURE =
  'FETCH_MOVEMENT_COMPLETE_FAILURE';

export const FETCH_OBJECT_NUM_REQUEST = 'FETCH_OBJECT_NUM_REQUEST';
export const FETCH_OBJECT_NUM_SUCCESS = 'FETCH_OBJECT_NUM_SUCCESS';
export const FETCH_OBJECT_NUM_FAILURE = 'FETCH_OBJECT_NUM_FAILURE';

export const SAVE_CONDITION_REPORT_REQUEST = 'SAVE_CONDITION_REPORT_REQUEST';
export const SAVE_CONDITION_REPORT_SUCCESS = 'SAVE_CONDITION_REPORT_SUCCESS';
export const SAVE_CONDITION_REPORT_FAILURE = 'SAVE_CONDITION_REPORT_FAILURE';

export const FETCH_CONDITION_REPORTS_REQUEST =
  'FETCH_CONDITION_REPORTS_REQUEST';
export const FETCH_CONDITION_REPORTS_SUCCESS =
  'FETCH_CONDITION_REPORTS_SUCCESS';
export const FETCH_CONDITION_REPORTS_FAILURE =
  'FETCH_CONDITION_REPORTS_FAILURE';

export const FETCH_CONDITION_REPORT_REQUEST = 'FETCH_CONDITION_REPORT_REQUEST';
export const FETCH_CONDITION_REPORT_SUCCESS = 'FETCH_CONDITION_REPORT_SUCCESS';
export const FETCH_CONDITION_REPORT_FAILURE = 'FETCH_CONDITION_REPORT_FAILURE';

export const DELETE_CONDITION_REPORT_REQUEST =
  'DELETE_CONDITION_REPORT_REQUEST';
export const DELETE_CONDITION_REPORT_SUCCESS =
  'DELETE_CONDITION_REPORT_SUCCESS';
export const DELETE_CONDITION_REPORT_FAILURE =
  'DELETE_CONDITION_REPORT_FAILURE';

export const SAVE_OBJ_MOVE_REQUEST = 'SAVE_OBJ_MOVE_REQUEST';
export const SAVE_OBJ_MOVE_SUCCESS = 'SAVE_OBJ_MOVE_SUCCESS';
export const SAVE_OBJ_MOVE_FAILURE = 'SAVE_OBJ_MOVE_FAILURE';

export const FETCH_OBJ_MOVES_REQUEST = 'FETCH_OBJ_MOVES_REQUEST';
export const FETCH_OBJ_MOVES_SUCCESS = 'FETCH_OBJ_MOVES_SUCCESS';
export const FETCH_OBJ_MOVES_FAILURE = 'FETCH_OBJ_MOVES_FAILURE';

export const FETCH_OBJ_MOVE_REQUEST = 'FETCH_OBJ_MOVE_REQUEST';
export const FETCH_OBJ_MOVE_SUCCESS = 'FETCH_OBJ_MOVE_SUCCESS';
export const FETCH_OBJ_MOVE_FAILURE = 'FETCH_OBJ_MOVE_FAILURE';

export const DELETE_OBJ_MOVE_REQUEST = 'DELETE_OBJ_MOVE_REQUEST';
export const DELETE_OBJ_MOVE_SUCCESS = 'DELETE_OBJ_MOVE_SUCCESS';
export const DELETE_OBJ_MOVE_FAILURE = 'DELETE_OBJ_MOVE_FAILURE';

export const FETCH_MAX_REPORT_ID_REQUEST = 'FETCH_MAX_REPORT_ID_REQUEST';
export const FETCH_MAX_REPORT_ID_SUCCESS = 'FETCH_MAX_REPORT_ID_SUCCESS';
export const FETCH_MAX_REPORT_ID_FAILURE = 'FETCH_MAX_REPORT_ID_FAILURE';

export const SAVE_TREATMENT_REPORT_REQUEST = 'SAVE_TREATMENT_REPORT_REQUEST';
export const SAVE_TREATMENT_REPORT_SUCCESS = 'SAVE_TREATMENT_REPORT_SUCCESS';
export const SAVE_TREATMENT_REPORT_FAILURE = 'SAVE_TREATMENT_REPORT_FAILURE';

export const FETCH_TREATMENT_REPORTS_REQUEST =
  'FETCH_TREATMENT_REPORTS_REQUEST';
export const FETCH_TREATMENT_REPORTS_SUCCESS =
  'FETCH_TREATMENT_REPORTS_SUCCESS';
export const FETCH_TREATMENT_REPORTS_FAILURE =
  'FETCH_TREATMENT_REPORTS_FAILURE';

export const FETCH_TREATMENT_REPORT_REQUEST = 'FETCH_TREATMENT_REPORT_REQUEST';
export const FETCH_TREATMENT_REPORT_SUCCESS = 'FETCH_TREATMENT_REPORT_SUCCESS';
export const FETCH_TREATMENT_REPORT_FAILURE = 'FETCH_TREATMENT_REPORT_FAILURE';

export const DELETE_TREATMENT_REPORT_REQUEST =
  'DELETE_TREATMENT_REPORT_REQUEST';
export const DELETE_TREATMENT_REPORT_SUCCESS =
  'DELETE_TREATMENT_REPORT_SUCCESS';
export const DELETE_TREATMENT_REPORT_FAILURE =
  'DELETE_TREATMENT_REPORT_FAILURE';

export const FETCH_USER_GROUP_REQUEST = 'FETCH_USER_GROUP_REQUEST';
export const FETCH_USER_GROUP_SUCCESS = 'FETCH_USER_GROUP_SUCCESS';
export const FETCH_USER_GROUP_FAILURE = 'FETCH_USER_GROUP_FAILURE';

export const FETCH_USER_GROUP_PERM_OBJECT_REQUEST =
  'FETCH_USER_GROUP_PERM_OBJECT_REQUEST';
export const FETCH_USER_GROUP_GROUP_PERM_OBJECT_SUCCESS =
  'FETCH_USER_GROUP_GROUP_PERM_OBJECT_SUCCESS';
export const FETCH_USER_GROUP_GROUP_PERM_OBJECT_FAILURE =
  'FETCH_USER_GROUP_GROUP_PERM_OBJECT_FAILURE';

export const SAVE_USER_GROUP_REQUEST = 'SAVE_USER_GROUP_REQUEST';
export const SAVE_USER_GROUP_SUCCESS = 'SAVE_USER_GROUP_SUCCESS';
export const SAVE_USER_GROUP_FAILURE = 'SAVE_USER_GROUP_FAILURE';

export const FETCH_CURRENT_USER_REQUEST = 'FETCH_CURRENT_USER_REQUEST';
export const FETCH_CURRENT_USER_SUCCESS = 'FETCH_CURRENT_USER_SUCCESS';
export const FETCH_CURRENT_USER_FAILURE = 'FETCH_CURRENT_USER_FAILURE';

export const DELETE_USER_GROUP_REQUEST = 'DELETE_USER_GROUP_REQUEST';
export const DELETE_USER_GROUP_SUCCESS = 'DELETE_USER_GROUP_SUCCESS';
export const DELETE_USER_GROUP_FAILURE = 'DELETE_USER_GROUP_FAILURE';

export const SAVE_PERSONAL_DETAILS_REQUEST = 'SAVE_PERSONAL_DETAILS_REQUEST';
export const SAVE_PERSONAL_DETAILS_SUCCESS = 'SAVE_PERSONAL_DETAILS_SUCCESS';
export const SAVE_PERSONAL_DETAILS_FAILURE = 'SAVE_PERSONAL_DETAILS_FAILURE';

export const SAVE_SECURITY_DETAILS_REQUEST = 'SAVE_SECURITY_DETAILS_REQUEST';
export const SAVE_SECURITY_DETAILS_SUCCESS = 'SAVE_SECURITY_DETAILS_SUCCESS';
export const SAVE_SECURITY_DETAILS_FAILURE = 'SAVE_SECURITY_DETAILS_FAILURE';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const SAVE_USER_REQUEST = 'SAVE_USER_REQUEST';
export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS';
export const SAVE_USER_FAILURE = 'SAVE_USER_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const SAVE_AVATAR_REQUEST = 'SAVE_AVATAR_REQUEST';
export const SAVE_AVATAR_SUCCESS = 'SAVE_AVATAR_SUCCESS';
export const SAVE_AVATAR_FAILURE = 'SAVE_AVATAR_FAILURE';

export const FETCH_ITEM_SUMMARY_REQUEST = 'FETCH_ITEM_SUMMARY_REQUEST';
export const FETCH_ITEM_SUMMARY_SUCCESS = 'FETCH_ITEM_SUMMARY_SUCCESS';
export const FETCH_ITEM_SUMMARY_FAILURE = 'FETCH_ITEM_SUMMARY_FAILURE';

export const FETCH_ITEM_ANALYSIS_SUMMARY_REQUEST =
  'FETCH_ITEM_ANALYSIS_SUMMARY_REQUEST';
export const FETCH_ITEM_ANALYSIS_SUMMARY_SUCCESS =
  'FETCH_ITEM_ANALYSIS_SUMMARY_SUCCESS';
export const FETCH_ITEM_ANALYSIS_SUMMARY_FAILURE =
  'FETCH_ITEM_ANALYSIS_SUMMARY_FAILURE';

export const FETCH_TREATMENT_SUMMARY_REQUEST =
  'FETCH_TREATMENT_SUMMARY_REQUEST';
export const FETCH_TREATMENT_SUMMARY_SUCCESS =
  'FETCH_TREATMENT_SUMMARY_SUCCESS';
export const FETCH_TREATMENT_SUMMARY_FAILURE =
  'FETCH_TREATMENT_SUMMARY_FAILURE';

export const FETCH_MOVEMENT_SUMMARY_REQUEST = 'FETCH_MOVEMENT_SUMMARY_REQUEST';
export const FETCH_MOVEMENT_SUMMARY_SUCCESS = 'FETCH_MOVEMENT_SUMMARY_SUCCESS';
export const FETCH_MOVEMENT_SUMMARY_FAILURE = 'FETCH_MOVEMENT_SUMMARY_FAILURE';

export const FETCH_CONDITION_SUMMARY_REQUEST =
  'FETCH_CONDITION_SUMMARY_REQUEST';
export const FETCH_CONDITION_SUMMARY_SUCCESS =
  'FETCH_CONDITION_SUMMARY_SUCCESS';
export const FETCH_CONDITION_SUMMARY_FAILURE =
  'FETCH_CONDITION_SUMMARY_FAILURE';

export const FETCH_VISIT_SUMMARY_REQUEST = 'FETCH_VISIT_SUMMARY_REQUEST';
export const FETCH_VISIT_SUMMARY_SUCCESS = 'FETCH_VISIT_SUMMARY_SUCCESS';
export const FETCH_VISIT_SUMMARY_FAILURE = 'FETCH_VISIT_SUMMARY_FAILURE';

export const SET_ITEM_AS_FILTERED = 'SET_ITEM_AS_FILTERED';
export const SET_ITEM_SEARCH_AS_ADVANCED = 'SET_ITEM_SEARCH_AS_ADVANCED';
export const UPDATE_ITEM_FILTER = 'UPDATE_ITEM_FILTER';
export const RESET_ITEM_FILTER = 'RESET_ITEM_FILTER';

export const SET_CONDITION_AS_FILTERED = 'SET_CONDITION_AS_FILTERED';
export const UPDATE_CONDITION_FILTER = 'UPDATE_CONDITION_FILTER';
export const RESET_CONDITION_FILTER = 'RESET_CONDITION_FILTER';

export const SET_TREATMENT_AS_FILTERED = 'SET_TREATMENT_AS_FILTERED';
export const UPDATE_TREATMENT_FILTER = 'UPDATE_TREATMENT_FILTER';
export const RESET_TREATMENT_FILTER = 'RESET_TREATMENT_FILTER';

export const SET_MOVEMENT_AS_FILTERED = 'SET_MOVEMENT_AS_FILTERED';
export const UPDATE_MOVEMENT_FILTER = 'UPDATE_MOVEMENT_FILTER';
export const RESET_MOVEMENT_FILTER = 'RESET_MOVEMENT_FILTER';

export const FETCH_RECENT_ACTIVITIES_REQUEST =
  'FETCH_RECENT_ACTIVITIES_REQUEST';
export const FETCH_RECENT_ACTIVITIES_SUCCESS =
  'FETCH_RECENT_ACTIVITIES_SUCCESS';
export const FETCH_RECENT_ACTIVITIES_FAILURE =
  'FETCH_RECENT_ACTIVITIES_FAILURE';

export const FETCH_AUDIT_TRAIL_REQUEST = 'FETCH_AUDIT_TRAIL_REQUEST';
export const FETCH_AUDIT_TRAIL_SUCCESS = 'FETCH_AUDIT_TRAIL_SUCCESS';
export const FETCH_AUDIT_TRAIL_FAILURE = 'FETCH_AUDIT_TRAIL_FAILURE';

// export const DELETE_CMS_LANGUAGE_FAILURE='DELETE_CMS_LANGUAGE_FAILURE'
// export const DELETE_CMS_LANGUAGE_REQUEST='DELETE_CMS_LANGUAGE_REQUEST'
// export const DELETE_CMS_LANGUAGE_SUCCESS='DELETE_CMS_LANGUAGE_SUCCESS'
// export const FETCH_CMS_LANGUAGES_FAILURE='FETCH_CMS_LANGUAGES_FAILURE'
// export const FETCH_CMS_LANGUAGES_REQUEST='FETCH_CMS_LANGUAGES_REQUEST'
// export const FETCH_CMS_LANGUAGES_SUCCESS='FETCH_CMS_LANGUAGES_SUCCESS'
// export const SAVE_CMS_LANGUAGE_FAILURE='SAVE_CMS_LANGUAGE_FAILURE'
// export const SAVE_CMS_LANGUAGE_REQUEST='SAVE_CMS_LANGUAGE_REQUEST'
// export const SAVE_CMS_LANGUAGE_SUCCESS='SAVE_CMS_LANGUAGE_SUCCESS'

export const RESET_NEWS_FILTER = 'RESET_NEWS_FILTER';
export const SET_NEWS_SEARCH_AS_ADVANCED = 'SET_NEWS_SEARCH_AS_ADVANCED';
export const SET_NEWS_AS_FILTERED = 'SET_NEWS_AS_FILTERED';
export const UPDATE_NEWS_FILTER = 'UPDATE_NEWS_FILTER';
export const RESET_BEACON_FILTER = 'RESET_BEACON_FILTER';
export const SET_BEACON_AS_FILTERED = 'SET_BEACON_AS_FILTERED';
export const SET_BEACON_SEARCH_AS_ADVANCED = 'SET_BEACON_SEARCH_AS_ADVANCED';
export const UPDATE_BEACON_FILTER = 'UPDATE_BEACON_FILTER';
